import { FC, useEffect, useState } from "react";
import "./SidebarChatsFeedbackAnalysisFilter.scss";
import SidebarFilter from "../../SidebarFilter/SidebarFilter";
import { useForm } from "react-hook-form";
import { Col, FormGroup, Row } from "react-bootstrap";
import ReactSelect from "react-select";
import { statusOption } from "../../../enums/Chat/ChatFeedbackStatusEnum";
import { useChatsFeedbackAnalysis } from "../../../providers/Chats/ChatsFeedbackAnalysisProvider";
import { customStyles } from "../../../models/SelectCustomStyles";
import moment from "moment";
import InputDateRange from "../../InputDateRange/InputDateRange";
import InputSearchPartner from "../../InputSearchPartner/InputSearchPartner";

interface SidebarChatsFeedbackAnalysisFilterProps {}

const userTypeOptions = [
  { value: 1, label: 'Parceiro' },
  { value: 0, label: 'Operacional' },
];

// @ts-ignore
export const defaultValues = {
  user_id: null,
  question: null,
  status_id: null,
  answer: null,
} as any;

const SidebarChatsFeedbackAnalysisFilter: FC<
  SidebarChatsFeedbackAnalysisFilterProps
> = () => {
  const [statusId, setStatusId] = useState<any>("");
  const [valuePartner, setValuePartner] = useState<any>();
  const [startDate, setStartDate] = useState<any>("");
  const [endDate, setEndDate] = useState<any>("");
  const [selectedUserType, setSelectedUserType] = useState<any | null>(null);

  const { handleSubmit, register, setValue, control } = useForm<any>({
    defaultValues,
  });
  const { setParams } = useChatsFeedbackAnalysis();

  useEffect(() => {
    setValue("user_id", valuePartner?.value);
  }, [valuePartner]);

  const onSubmit = async (data: any) => {
    const {
      page: _page,
      perPage: _perPage,
      withPaginate: _withPaginate,
      ...rest
    } = data;

    const filter: any = {
      ...rest,
      status_id: statusId?.value ?? null,
      user_id: data?.user_id?.value ? data?.user_id?.value : null,
      question: data?.question ? data?.question : null,
      answer: data?.answer ? data?.answer : null,
      start_date: startDate ? moment(startDate).format("YYYY-MM-DD") : null,
      end_date: endDate ? moment(endDate).format("YYYY-MM-DD") : null,
    };

    if (selectedUserType !== null) filter.commissioned = selectedUserType.value;

    setParams((prev: any) => {
      const merged: any = { ...(prev?.filter ?? {}), ...filter };
      if (filter.commissioned === undefined) delete merged.commissioned;
      return {
        ...prev,
        filter: merged,
        page: 1,
        perPage: prev?.perPage ?? 10,
        withPaginate: prev?.withPaginate ?? true,
      };
    });
  };

  useEffect(() => {
    setStatusId(statusOption.find((x) => x.value === 1) || null);
  }, [statusOption]);

  return (
    <SidebarFilter handleSubmit={handleSubmit(onSubmit)}>
      <div
        className="SidebarChatsFeedbackAnalysisFilter"
        data-testid="SidebarChatsFeedbackAnalysisFilter"
      >
        <Row className="mt-1">
          <Col>
            <FormGroup className="form-group">
              <label htmlFor="status_id">STATUS</label>
              <ReactSelect
                name={"status_id"}
                isClearable
                isSearchable
                options={statusOption}
                value={statusId}
                placeholder="Selecione"
                className={`form-control p-0 select-width`}
                noOptionsMessage={() => "Não há registros"}
                onChange={(e: any) => {
                  setStatusId(e);
                }}
                styles={customStyles}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row className="mt-1">
          <Col>
            <FormGroup className="form-group">
              <label htmlFor="user_id">USUÁRIO</label>
              <InputSearchPartner
                name="user_id"
                control={control}
                setValue={setValue}
                valuePartner={valuePartner}
                setValuePartner={setValuePartner}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row className="mt-1">
          <Col>
            <FormGroup className="form-group">
              <label>TIPO DE USUÁRIO</label>
              <ReactSelect
                isClearable
                options={userTypeOptions}
                value={selectedUserType}
                placeholder="Todos"
                className="form-control p-0"
                noOptionsMessage={() => "Não há registros"}
                styles={customStyles}
                onChange={(e) => setSelectedUserType(e ?? null)}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row className="mt-1">
          <Col>
            <InputDateRange
              startDate={startDate}
              setStartDate={setStartDate}
              endDate={endDate}
              setEndDate={setEndDate}
              setValue={setValue}
              startLabelText={"DATA INICIAL"}
              endLabelText={"DATA FINAL"}
            />
          </Col>
        </Row>
        <Row className="mt-1">
          <Col>
            <FormGroup className="form-group">
              <label htmlFor="question">PERGUNTA</label>
              <textarea
                className="form-control"
                rows={5}
                {...register("question")}
              ></textarea>
            </FormGroup>
          </Col>
        </Row>
        <Row className="mt-1">
          <Col>
            <FormGroup className="form-group">
              <label htmlFor="answer">RESPOSTA</label>
              <textarea
                className="form-control"
                rows={5}
                {...register("answer")}
              ></textarea>
            </FormGroup>
          </Col>
        </Row>
      </div>
    </SidebarFilter>
  );
};

export default SidebarChatsFeedbackAnalysisFilter;
